import { QueryFilter, QueryIface, QueryMergeCondition } from '@kentik/ui-shared/types/queries';
import DeviceModel from 'app/stores/device/DeviceModel';
import $metrics from 'app/stores/metrics/$metrics';

export enum FlowMeasurement {
  FLOW = '/kentik/licensing/flow',
  FLOW_PROXY = '/kentik/licensing/flow/flowproxy',
  KPROXY = '/kentik/licensing/flow/kproxy'
}

export function getDeviceFlowMeasurement(device: DeviceModel): string {
  if (!device || !device.get('stats')) {
    console.warn('Device or device stats not defined, defaulting to /flow query measurement');
  }

  let measurement = FlowMeasurement.FLOW; // Default to /flow measurement

  const IsAgent = (device.get('stats') as { IsAgent: number } | undefined)?.IsAgent;

  // If IsAgent is defined and greater than 0, use flowproxy/kproxy measurements
  if (!!IsAgent && IsAgent > 0) {
    if (device.get('device_kentik_agent_id') && $metrics.measurementModelByName(FlowMeasurement.FLOW_PROXY)) {
      measurement = FlowMeasurement.FLOW_PROXY;
    } else if (!device.get('device_kentik_agent_id') && $metrics.measurementModelByName(FlowMeasurement.KPROXY)) {
      measurement = FlowMeasurement.KPROXY;
    }
  }

  return measurement;
}

type FlowQueryParams = {
  dimensions: string[];
  filters?: QueryFilter[];
  limit?: number;
  lookback: string;
  metric: string;
  measurement: string;
  merge?: QueryMergeCondition | null;
  rollup?: string;
};
export function getFlowQueries({
  dimensions,
  filters = [],
  limit = 100,
  lookback,
  metric,
  measurement,
  merge,
  rollup = 'avg'
}: FlowQueryParams): QueryIface | null {
  const query: QueryIface = {
    update_frequency: 0,
    use_kmetrics: true,
    show_overlay: false,
    show_total_overlay: false,
    kmetrics: {
      measurement,
      dimensions,
      metrics: [{ name: metric, type: 'gauge' }],
      range: { lookback },
      window: {
        size: 0,
        fn: {
          [`${metric}`]: 'avg'
        }
      },
      rollups: {
        [`${rollup}_${metric}`]: { metric, aggregate: `${rollup}` }
      },
      sort: [{ direction: 'desc', name: `last_${metric}` }],
      limit,
      includeTimeseries: 20,
      streamingUpdate: false,
      filters: {
        connector: 'All',
        filterGroups: [
          {
            name: '',
            named: false,
            connector: 'All',
            not: false,
            filters
          }
        ]
      }
    }
  };

  if (merge) {
    query.kmetrics.merge = merge;
  }
  return query;
}
